// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "store" + "." + "4828e32b" + ".chunk.css");